<style scoped>

</style>
<script>
import { layoutMethods } from "@/state/helpers";
import { menuItems } from "./horizontal-menu";
import {  mapGetters } from "vuex";
import {  abilityCheck } from "@/helpers/helper.js";

export default {
  data() {
    return {
      menuItems: menuItems,
    };
  },
  mounted() {
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const routerActiveLink = document.getElementsByClassName('router-link-exact-active')
    if(routerActiveLink){
      
      routerActiveLink[0]?.closest('.dropdown')?.classList.add('active')
    }
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */

      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add("active");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add("active");
                const parent6 = parent5.parentElement;
                if (parent6) {
                  parent6.classList.add("active");
                }
              }
            }
          }
        }
      }
    }
  },
   computed: {
      ...mapGetters('authfack',['userdata'])
  },
  methods: {
    ...layoutMethods,
    /** 
     * Menu clicked show the submenu
     */
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling;
      if (nextEl && !nextEl.classList.contains("show")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.add("show");
      } else if (nextEl) {
        nextEl.classList.remove("show");
      }
      return false;
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    checkRole(role){
      const userdata = JSON.parse(localStorage.getItem('userdata')) 
      if(abilityCheck(role.key)){
        return true
      }
      if(role.auth){
        if(role.auth.indexOf('|')){
          return role.auth.split('|').includes(userdata.role_name)
        }
      }
      return true;
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
  },
};
</script>
<template>
<div class="topnav">
  <div class="container-fluid">
    <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
          <div class="collapse navbar-collapse" id="topnav-menu-content" >
            <ul class="navbar-nav">
              <!-- Menu data -->
              <template v-for="(item, index) of menuItems">
                <li class="nav-item dropdown text-start" :key="index" v-if="checkRole(item)">
                  <router-link
                    class="nav-link dropdown-toggle arrow-none"
                    v-if="!item.subItems"
                    :to="item.link"
                    role="button"
                  > 
                    <div>{{ $t(item.label) }}</div>
                    <div class="arrow-down" v-if="hasItems(item)"></div>
                  </router-link>
                  <a
                    v-if="item.subItems"
                    class="nav-link dropdown-toggle arrow-none"
                    @click="onMenuClick($event)"
                    role="button"
                  >
                  {{ $t(item.label) }}
                  <div class="arrow-down"></div>
                  </a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="topnav-dashboard"
                    v-if="hasItems(item)"
                  >
                    <template v-for="(subitem, index) of item.subItems">
                      <router-link
                        class="col dropdown-item side-nav-link-ref"
                        :key="index"
                        v-if="checkRole(subitem)"
                        :to="subitem.link"
                        >{{ $t(subitem.label) }}</router-link
                      >
                    </template>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </nav>
    </div>
  </div>
</template>